import * as React from "react";
import { SVGProps } from "react";
export function MemberGlobeIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={31}
      height={31}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g
        clipPath="url(#member-globe_svg__a)"
        stroke="#EB773D"
        strokeWidth={1.3}
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M24.871 24.875a5.6 5.6 0 0 0-5.283-3.75 5.6 5.6 0 0 0-5.283 3.75M16.156 16.433a3.433 3.433 0 1 0 6.867 0 3.433 3.433 0 0 0-6.867 0Z" />
        <path d="M10.284 23.292A9.374 9.374 0 1 1 24.575 13.15" />
        <path d="M12.163 21.667a21.724 21.724 0 0 1-.75-9.867c.216-1.91.838-3.75 1.825-5.4M6.14 14.875h7.484M7.57 10.5h15.867M6.906 19.25h6.717M17.758 6.4a11.924 11.924 0 0 1 1.6 4.1" />
      </g>
      <defs>
        <clipPath id="member-globe_svg__a">
          <path fill="#fff" transform="translate(5.5 5.5)" d="M0 0h20v20H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
